import { createSelector } from 'reselect'
import _ from 'lodash'

const jsonSelector = key => state => _.get(state, `${key}.json`, {})

export default createSelector(jsonSelector, _.identity)



// WEBPACK FOOTER //
// ./src/selectors/json.js